import { combineReducers } from 'redux';

import { createNamedWrapperReducer } from '../../utils/createNamedWrapperReducer';
import { SelectionListAction, SelectionActionKeys, SelectionType } from './actions';

export interface SelectionState {
	[SelectionType.RESOURCES]: number[];
	[SelectionType.NOTES]: number[];
}

const initialState = [];

const ids = (state: number[] = initialState, action: SelectionListAction): number[] => {
	switch (action.type) {
		case SelectionActionKeys.LOAD_SELECTION:
		case SelectionActionKeys.TOGGLE_SELECTION:
		case SelectionActionKeys.REMOVE_FROM_SELECTION:
			return action.selectionIds;
		case SelectionActionKeys.CLEAR_SELECTION:
			return initialState;
		default:
			return state;
	}
};

export const selection = combineReducers({
	[SelectionType.RESOURCES]: createNamedWrapperReducer(ids, SelectionType.RESOURCES),
	[SelectionType.NOTES]: createNamedWrapperReducer(ids, SelectionType.NOTES),
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Selection/reducer.ts